<script>

  import Modal from '@/components/Modal/Modal'
  import cookieManager from '@/libs/cookie-manager'

  import './style.scss'

  import {
    PLAN_FREE,
  } from '@/constants'

  export default {
    name: 'hero',
    components: {
      Modal,
    },
    data: () => ({
      showErrorModal: false,
      showSuccessModal: false,
      errorMessage: null,
      email: '',
    }),
    beforeCreate() {
      this.PLAN_FREE = PLAN_FREE
    },
    methods: {
      showModal(type) {
        this.showErrorModal = true;
      },
      async resendVerificationEmail () {
        let email = this.email
        const res = await fetch('/api2/resend', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
                        email,
          }),
        })
        let body = await res.json()
        if (body.error) {
            this.errorMessage = body.message
            this.showErrorModal = true
        } else {
            this.redirectToSubscribe(email)
        }
      },
      async getSub (planType) {
        // TODO: check email is valid.
        let email = this.email

        const referrer = cookieManager.getRef()
        const res = await fetch('/api2/subscribe', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email,
            referrer,
          }),
        })
        let body = await res.json()
        if (body.error || this.errors.first('email')) {
          this.errorMessage = body.message
          if (this.errors.first('email')) {
            this.errorMessage = this.errors.first('email')
          }
          this.showErrorModal = true
        } else {
          this.showSuccessModal = true
        }
      },

      redirectToSubscribe(email) {
        const encodedEmail = encodeURIComponent(email)
        const referrer = cookieManager.getRef()
        if (referrer) {
          this.$router.push(`subscribe?email=${encodedEmail}&ref=${referrer}`)
        } else {
          this.$router.push(`subscribe?email=${encodedEmail}`)
        }
      },

    }
  }

</script>

<template>
  <div class='hero'>
    <a class='anchor' id='subscribe'></a>
    <Modal
      :show="showSuccessModal"
      :type="'success'"
    >
      <div class='subscribe-modal'>
        <strong>Success!</strong>
        <br />
        <br />
        <p>
          Just one thing: to start receiving problems, we need to verify your email address.
        </p>
        <p>
           Could you <b>please check your email for a verification link</b>? Thanks!
        </p>
        <p>
          Thanks for subscribing! We hope you enjoy our daily programming problems.
        </p>

        <button class='green' @click="redirectToSubscribe(email)">I verified my email address!</button>
      </div>
    </Modal>


    <Modal
      :show="showErrorModal"
      :type="'error'"
      @close="showErrorModal = false"
    >
      <div class='subscribe-modal'>
        <strong>Error!</strong>
        <br />
        <br />
        <p>{{ errorMessage }}</p>
        <p v-if='errorMessage === "You are already enrolled to Daily Coding Problem!"'>
                    You should have received a verification email from us. If you didn't receive it, click below to to get one resent to your email.
        </p>
        <p v-if='!this.errors.first("email")'>
          Otherwise, please contact us at <a href='mailto:founders@dailycodingproblem.com?Subject=Hello!' target='_top'>founders@dailycodingproblem.com</a> and let us know what's going on.
        </p>
        <button v-if='errorMessage === "You are already enrolled to Daily Coding Problem!"' class='green' @click="resendVerificationEmail()">Resend Verification Email</button>
        <button @keyup.esc="showErrorModal = false" class='green' @click="showErrorModal = false">Close</button>
      </div>
    </Modal>
    <header>
      Ace your programming interview
    </header>
    <p class='slogan'>
      Get <i>exceptionally</i> good at coding interviews by solving one problem every day.
    </p>
    <p v-if='count' class='slogan'>
      Join <strong>88,218</strong> other coders practicing for interviews!
    </p>
    <div class='cta-container'>
      <form @submit.prevent='getSub(PLAN_FREE)' class='email-input'>
        <input
          v-model='email'
          class='email'
          type='text'
          placeholder='Enter your email...'
          v-validate='"required|email"'
          required
          name='email'
          data-vv-validate-on="none"
          autocomplete='off'
        />
        <button class='cta dark'>
          Subscribe to Daily Coding Problem
        </button>
      </form>
      <p class='disclaimer'>
        No spam, ever. Easy unsubscribe.
      </p>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// src/components/Hero/Hero.vue